import Link from "next/link";

export default function TitleTemplate({ titleName, link }) {

    return (
        <div className="flex bg-primary h-10 rounded-t-[5px]">
            <Link href={link || '#'} className={`w-full font-bold text-lg text-center m-auto text-white ${link ? "" : "pointer-events-none"}`}>
                <span className="w-full text-center uppercase">
                    {titleName}
                </span>
            </Link>
        </div>
    )
}
